import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const whatsappMessage = encodeURIComponent(
    "Olá, vi o site da Lar do Eletro e gostaria de informações sobre conserto, peças ou utensílios."
  );
  const whatsappUrl = `https://wa.me/555132764130?text=${whatsappMessage}`;

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Conserto, Peças e Utensílios Domésticos
            </h1>
            <p className="hero-subtitle">
              Soluções profissionais para seus eletrodomésticos, com orçamento gratuito e 90 dias de garantia em todos os serviços.
            </p>
            <div className="hero-buttons">
              <a 
                href={whatsappUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary hero-cta"
              >
                Solicitar Orçamento Grátis
              </a>
              <a 
                href="#contact-form" 
                className="btn btn-secondary hero-cta"
              >
                Agendar Atendimento Online
              </a>
            </div>
            <ul className="hero-trust">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="trust-icon">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 12l2.5 2.5L16 9" />
                </svg>
                90 dias de garantia
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="trust-icon">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 12l2.5 2.5L16 9" />
                </svg>
                Orçamento grátis
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="trust-icon">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 12l2.5 2.5L16 9" />
                </svg>
                Serviço rápido e confiável
              </li>
            </ul>
          </div>
          <div className="hero-image">
            <img
              src="/store-image.jpg"
              alt="Loja Lar do Eletro"
              className="hero-photo"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
